import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView boxShadow="0 2px 2px rgba(0,0,0,.5)" column center>
          <CFImage
            w="100%"
            src={mobileHero}
            alt="Sushi S Japanese Restaurant Logo Title"
          />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView w="100%" zIndex={90} column center maxWidth="1400px">
          <CFImage
            w="100%"
            src={hero}
            alt="Sushi S Japanese Restaurant Logo Title"
          />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
